import PageContent from './PageContent.component';

export default PageContent;